export default __webpack_public_path__ + "static/media/su-calculator-eol-device.398c181d.png";